module.exports = __webpack_public_path__ + "static/media/harish_pic.38665125.jpg";